import { boolean, RoomId, roomId, StreamId, streamId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomStreamAudioUpdateEventDTO {
  private static validation = JsonSchemaValidator.compile(
    RoomStreamAudioUpdateEventDTO.validationSchema()
  );

  constructor(readonly data: RoomStreamAudioUpdateEventDTORaw) {
    JsonSchemaValidator.assert(RoomStreamAudioUpdateEventDTO.validation, data);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "streamId", "isEnabled"],
      properties: {
        roomId,
        streamId,
        isEnabled: boolean
      },
      additionalProperties: false
    };
  }
}

export interface RoomStreamAudioUpdateEventDTORaw {
  roomId: RoomId;
  streamId: StreamId;
  isEnabled: boolean;
}
